'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  calendars: {
    calendarFormOptionsBox: {
      allowEventDelete: 'Allow event deletion',
      audiences: 'Audiences',
      categories: 'Categories',
      hide: 'Hide',
      media: 'Images',
      multipleMedia: 'Multiple media',
      show: 'Show',
      singleMedia: 'Single media',
      taxonomies: 'Taxonomies',
      title: 'Form and Classification',
      groups: 'Groups',
      tags: 'Tags',
      organization: 'Organization',
      contactInformation: 'Contact information',
      widget: 'Widget creation',
      multipleVenues: 'Multiple venues',
      types: 'Types',
      regions: 'Regions'
    },
    calendarOptions: 'Calendar options',
    createWidget: 'Create Widget',
    form: {
      confirmSave: 'Do you want to save the changes made in this calendar\xA0?'
    },
    widget: {
      number: 'Maximum number of events',
      width: 'Width',
      height: 'Height',
      filters: 'Filters',
      copy: 'Copy Code',
      copied: 'Copied!',
      hideRecurrences: 'Hide recurring events'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/calendars.js
// module id = 2282
// module chunks = 0